import { SagaIterator } from "redux-saga";

function* rootSaga(): SagaIterator {
  // yield fork(watchFetchUser)
  // yield fork(watchLogin)
}

export default rootSaga;
